<p>
    <a
        href="https://t.me/moddyai"
        target="_blank">
        <p-button
            [label]="'Telegram'"
            [link]="true" />
    </a>
</p>
